import { FetchError } from "ofetch";

const VALIDATION_ERROR_CODE = 422;
const SERVER_ERROR_CODE = 500;

type ValidationError = {
  [key: string]: string[];
};

const normalizeValidationErrors = (errorData: any): ValidationError => {
  if (errorData.errors) {
    return errorData.errors;
  }

  if (errorData.data) {
    return Object.entries(errorData.data).reduce((acc, [key, messages]) => {
      // Convert dot notation to a consistent format
      const normalizedKey = Array.isArray(messages)
        ? key
        : key
          .split(".")
          .filter((part) => isNaN(Number(part)))
          .join("_");

      acc[normalizedKey] = Array.isArray(messages) ? messages : [messages];
      return acc;
    }, {} as ValidationError);
  }

  return {};
};
const getFieldError = (bag: ValidationError, field: string): string => {
  const normalizedField = field
    .split(".")
    .filter((part) => isNaN(Number(part)))
    .join("_");

  return bag[normalizedField]?.[0] ?? "";
};
const formatErrorSummary = (bag: ValidationError): string => {
  const uniqueErrors = [...new Set(Object.values(bag).flat().filter(Boolean))];

  if (uniqueErrors.length === 0) {
    return "";
  }

  if (uniqueErrors.length === 1) {
    return uniqueErrors[0];
  }

  const lastError = uniqueErrors.pop();
  return `${uniqueErrors.join(", ")} and ${lastError}`;
};
export const useApiError = (error: any) => {
  const isFetchError = error instanceof FetchError;
  const isValidationError =
    isFetchError && error.response?.status === VALIDATION_ERROR_CODE;
  const code = isFetchError
    ? error?.response?.status
    : (error?.status ?? SERVER_ERROR_CODE);
  const message = isFetchError
    ? (error.data?.message ?? error.response?._data?.message ?? error.message)
    : null;
  const bag: Record<string, string[]> = isValidationError
    ? normalizeValidationErrors(error.response?._data)
    : {};
  return {
    isValidationError,
    code,
    bag,
    message,
    fieldError: (field: string) => getFieldError(bag, field),
    summary: formatErrorSummary(bag),
  };
};
